import React from "react";
import {observer} from "mobx-react";
import {IonMenu} from "@ionic/react";
import {BookingSearchFiltersComponent} from "./booking-search-filters.component";
import styled from "styled-components";
import { useServices } from "../../../hooks/use-services.hook";
import {CloseSideMenuButtonComponent} from "../../../components/burger-menu/close-side-menu-button.component";

const IonMenuBox = styled(IonMenu)`

    ${props => props.theme.screenMediaQuery.xsAndBelow} {
        width: 100vw;
        &::part(container) {
            box-sizing: border-box;
            width: 100vw;
            padding: ${props => props.theme.spacing.spacing16};
        }    
    }
`

const HeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
`

export const BookingSearchFiltersAsSideMenuComponent = observer(() => {
    const services = useServices();
    const sideMenuController = services.sideMenu.agencyBookingSearchSideMenuController;
    return (
        <IonMenuBox menuId={sideMenuController.menuId}
                    contentId={sideMenuController.contentId}
                    side={"start"}>
            <HeaderBox>
                <CloseSideMenuButtonComponent sideMenuController={sideMenuController} />
            </HeaderBox>
            <BookingSearchFiltersComponent/>
        </IonMenuBox>
    )
})